import * as Sentry from "@sentry/react";

/**
 * [AI GENERATED CODE]
 * Single shared Sentry initializer for all entry points.
 * Reads APP_CONFIG, APP_VERSION, IS_PROD from globals.
 * Call once, early in app boot, before rendering.
 * @param {Object} [userInfo] - Optional user context
 * @param {string} userInfo.id - User analytics ID
 * @param {Object} [userInfo.extras] - Additional user context
 */
export const initSentry = (userInfo) => {
    if (window.__sentryInitialized__) {
        if (userInfo?.id) {
            Sentry.setUser({ id: userInfo.id });
        }
        if (userInfo?.extras) {
            Sentry.setExtras(userInfo.extras);
        }
        return;
    }
    window.__sentryInitialized__ = true;

    Sentry.init({
        enabled: APP_CONFIG?.sentry?.enabled,
        dsn: APP_CONFIG?.sentry?.dsn,
        environment: APP_CONFIG?.sentry?.env,
        debug: !IS_PROD,
        release: APP_VERSION,
        sampleRate: APP_CONFIG?.sentry?.sampleRate,
        tracesSampleRate: APP_CONFIG?.sentry?.tracesSampleRate,
        profilesSampleRate: 0.2,
        maxBreadcrumbs: 10,
        ignoreErrors: [
            /Error sending event '.*': .* should be of type/,
        ],
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.globalHandlersIntegration(),
            Sentry.linkedErrorsIntegration(),
            Sentry.dedupeIntegration(),
            Sentry.extraErrorDataIntegration(),
            Sentry.breadcrumbsIntegration(),
            Sentry.captureConsoleIntegration({
                levels: ["error"],
            })
        ],
    });

    if (userInfo?.id) {
        Sentry.setUser({ id: userInfo.id });
    }

    if (userInfo?.extras) {
        Sentry.setExtras(userInfo.extras);
    }

};
